import React from 'react';
import TextContent from '../TextContent';
import _ from 'lodash';
import Link from '../Link/Link';
import RichText from '../RichText'


const ContentWysiwyg = ({ entity, withWrapper }) => {
  const body = entity.fieldBody && <RichText body={_.get(entity, 'fieldBody.processed', '')} />;
  const link = _.get(entity, 'fieldMoreLink.url.path')

  return (
    <TextContent extraClassName="page-text-content">
      { entity.fieldTitle &&
        <h2 className="title">
          {link ? <Link href={link}>{entity.fieldTitle}</Link> : entity.fieldTitle}
        </h2>
      }

      {withWrapper ? <div className="text-wrapper">{body}</div> : body}

      {link && (
        <Link type="arrow" href={link} label={_.get(entity, 'fieldMoreLinkLabel', null)}>
          {_.get(entity, 'fieldMoreLink.title')}
        </Link>
      )}
    </TextContent>
  );
}

ContentWysiwyg.propTypes = {

};

export default ContentWysiwyg;
